import {ConnectionHandler, type RecordProxy} from 'relay-runtime'

/**
 * Inserts a label edge into the connection in alphabetical order by label name.
 * This ensures the optimistic update matches the server's alphabetical ordering
 * and prevents a visual jump when the server response arrives.
 */
export function insertLabelEdgeInAlphabeticalOrder(connection: RecordProxy, edge: RecordProxy, labelName: string) {
  const edges = connection.getLinkedRecords('edges')
  if (!edges || edges.length === 0) {
    ConnectionHandler.insertEdgeBefore(connection, edge)
    return
  }

  // Find the correct position to insert the new label in alphabetical order
  let insertIndex = edges.length
  for (let i = 0; i < edges.length; i++) {
    const existingEdge = edges[i]
    if (!existingEdge) continue

    const node = existingEdge.getLinkedRecord('node')
    if (!node) continue

    const existingLabelName = node.getValue('name')
    if (typeof existingLabelName === 'string' && labelName.localeCompare(existingLabelName) < 0) {
      insertIndex = i
      break
    }
  }

  if (insertIndex === 0) {
    // Insert at the beginning
    ConnectionHandler.insertEdgeBefore(connection, edge)
  } else if (insertIndex >= edges.length) {
    // Insert at the end
    ConnectionHandler.insertEdgeAfter(connection, edge)
  } else {
    // Insert before the edge at insertIndex
    // We need to rebuild the edges array with the new edge in the correct position
    const newEdges = [...edges.slice(0, insertIndex), edge, ...edges.slice(insertIndex)]
    connection.setLinkedRecords(newEdges, 'edges')
  }
}
